// app/javascript/pages/dashboard.ts

export function initDashboard(): void {
  animateLeagueWidget();
  animateEloDisplay();
}

function animateEloDisplay() {
  const eloCircle = document.querySelector(".elo-circle") as HTMLElement;
  const rankText = document.querySelector(".rank-text") as HTMLElement;

  if (eloCircle && rankText) {
    eloCircle.style.opacity = "0";
    rankText.style.transform = "translateY(20px)";
    rankText.style.opacity = "0";

    setTimeout(() => {
      eloCircle.style.transition = "opacity 1s ease-out";
      eloCircle.style.opacity = "1";

      rankText.style.transition =
        "transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.8s ease-out";
      rankText.style.transform = "translateY(0)";
      rankText.style.opacity = "1";
    }, 100);
  }
}

function animateLeagueWidget() {
  const widget = document.querySelector(
    '[data-controller="league-widget"]',
  ) as HTMLElement;
  if (!widget) return;

  const progress = parseInt(widget.dataset.progress || "0");
  const nextLeagueIn = parseInt(
    widget.dataset.leagueWidgetNextLeagueInValue || "0",
  );
  const progressBar = widget.querySelector(
    '[data-league-widget-target="progressBar"]',
  ) as HTMLElement;
  const counter = widget.querySelector(
    '[data-league-widget-target="nextLeagueIn"]',
  ) as HTMLElement;

  if (progressBar) {
    setTimeout(() => {
      progressBar.style.transition =
        "transform 1.5s cubic-bezier(0.65, 0, 0.35, 1)";
      progressBar.style.transform = `scaleX(${progress / 100})`;
    }, 100);
  }

  if (counter) {
    // Calculate the total league range based on progress and remaining points
    // progress% of league_range = league_range - nextLeagueIn
    // league_range = nextLeagueIn / (1 - progress/100)
    const leagueRange = Math.round(
      nextLeagueIn / (1 - Math.min(progress, 99.9) / 100),
    );

    // Animate counter from total league range down to remaining points needed
    // For example: Gold league (300 points), at 1577 ELO (224 points to Platinum)
    // Animation goes from 300 down to 224
    animateCounter(counter, leagueRange, nextLeagueIn, 1500);
  }
}

function animateCounter(
  element: HTMLElement,
  start: number,
  end: number,
  duration: number,
) {
  let startTimestamp: number | null = null;

  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    const easeProgress = 1 - Math.pow(1 - progress, 3);
    const currentVal = Math.round(start + (end - start) * easeProgress);

    element.textContent = currentVal.toString();

    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      element.textContent = end.toString();
    }
  };

  window.requestAnimationFrame(step);
}
